import { serialize } from 'object-to-formdata'
import store from '@/store/store'
import { isArray, isObject, isString, isBoolean } from 'lodash'
import get from 'lodash/get'
import mapValues from 'lodash/mapValues'

import moment from 'moment'
import Vue from 'vue'


const mimeTypes = {
  a: 'application/octet-stream',
  ai: 'application/postscript',
  aif: 'audio/x-aiff',
  aifc: 'audio/x-aiff',
  aiff: 'audio/x-aiff',
  au: 'audio/basic',
  avi: 'video/x-msvideo',
  bat: 'text/plain',
  bin: 'application/octet-stream',
  bmp: 'image/x-ms-bmp',
  c: 'text/plain',
  cdf: 'application/x-cdf',
  csh: 'application/x-csh',
  css: 'text/css',
  dll: 'application/octet-stream',
  doc: 'application/msword',
  docx:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  dot: 'application/msword',
  dvi: 'application/x-dvi',
  eml: 'message/rfc822',
  eps: 'application/postscript',
  etx: 'text/x-setext',
  exe: 'application/octet-stream',
  gif: 'image/gif',
  gtar: 'application/x-gtar',
  h: 'text/plain',
  hdf: 'application/x-hdf',
  htm: 'text/html',
  html: 'text/html',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  js: 'application/x-javascript',
  ksh: 'text/plain',
  latex: 'application/x-latex',
  m1v: 'video/mpeg',
  man: 'application/x-troff-man',
  me: 'application/x-troff-me',
  mht: 'message/rfc822',
  mhtml: 'message/rfc822',
  mif: 'application/x-mif',
  mov: 'video/quicktime',
  movie: 'video/x-sgi-movie',
  mp2: 'audio/mpeg',
  mp3: 'audio/mpeg',
  mp4: 'video/mp4',
  mpa: 'video/mpeg',
  mpe: 'video/mpeg',
  mpeg: 'video/mpeg',
  mpg: 'video/mpeg',
  ms: 'application/x-troff-ms',
  nc: 'application/x-netcdf',
  nws: 'message/rfc822',
  o: 'application/octet-stream',
  obj: 'application/octet-stream',
  oda: 'application/oda',
  pbm: 'image/x-portable-bitmap',
  pdf: 'application/pdf',
  pfx: 'application/x-pkcs12',
  pgm: 'image/x-portable-graymap',
  png: 'image/png',
  pnm: 'image/x-portable-anymap',
  pot: 'application/vnd.ms-powerpoint',
  ppa: 'application/vnd.ms-powerpoint',
  ppm: 'image/x-portable-pixmap',
  pps: 'application/vnd.ms-powerpoint',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.ms-powerpoint',
  ps: 'application/postscript',
  pwz: 'application/vnd.ms-powerpoint',
  py: 'text/x-python',
  pyc: 'application/x-python-code',
  pyo: 'application/x-python-code',
  qt: 'video/quicktime',
  ra: 'audio/x-pn-realaudio',
  ram: 'application/x-pn-realaudio',
  ras: 'image/x-cmu-raster',
  rdf: 'application/xml',
  rgb: 'image/x-rgb',
  roff: 'application/x-troff',
  rtx: 'text/richtext',
  sgm: 'text/x-sgml',
  sgml: 'text/x-sgml',
  sh: 'application/x-sh',
  shar: 'application/x-shar',
  snd: 'audio/basic',
  so: 'application/octet-stream',
  src: 'application/x-wais-source',
  swf: 'application/x-shockwave-flash',
  t: 'application/x-troff',
  tar: 'application/x-tar',
  tcl: 'application/x-tcl',
  tex: 'application/x-tex',
  texi: 'application/x-texinfo',
  texinfo: 'application/x-texinfo',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  tr: 'application/x-troff',
  tsv: 'text/tab-separated-values',
  txt: 'text/plain',
  ustar: 'application/x-ustar',
  vcf: 'text/x-vcard',
  wav: 'audio/x-wav',
  wiz: 'application/msword',
  wsdl: 'application/xml',
  xbm: 'image/x-xbitmap',
  xlb: 'application/vnd.ms-excel',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xml: 'text/xml',
  xpdl: 'application/xml',
  xpm: 'image/x-xpixmap',
  xsl: 'application/xml',
  xwd: 'image/x-xwindowdump',
  zip: 'application/zip',
  ico: 'image/x-icon'
}

export const mimeType = function(mimeType: string) {
  for (const key in mimeTypes) {
    if (mimeTypes[key] === mimeType) return key
  }
  return null
}

export const popupCenter = function(url, title, w, h, opts) {

  var y = window.outerHeight / 2 + window.screenY - ( h / 2)
  var x = window.outerWidth / 2 + window.screenX - ( w / 2)
  const newWindow = window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);

  if (newWindow) {
      newWindow.focus();
  }

  return newWindow
}

export const isUserLoggedIn = () => {
  let userInfo: any = localStorage.getItem('userInfo')
  userInfo = JSON.parse(userInfo)
  if (userInfo === null) return false
  return 'token' in userInfo
}

export const responseMessagesHasErrorCode = (code: Number, messages: Array<string>) => {
  return messages.length !== 0 && !!messages[0].startsWith(`E0x${code.toString(16).toUpperCase()}`)
}

export const arraySortDate = (prop, sign = 1) => (a, b) => {
  const aDatestring = get(a, prop, null)
  const bDatestring = get(b, prop, null)

  if (aDatestring && bDatestring) {
    const aDate = moment(aDatestring)
    const bDate = moment(bDatestring)

    return Math.sign(aDate.diff(bDate)) * sign
  } else return 0
}

export const arraySort = (prop, sign = 1, useGet = false) => (a, b) => {
  let first = ''
  let second = ''
  if (useGet) {
    first = String(get(a, prop, '')).toUpperCase()
    second = String(get(b, prop, '')).toUpperCase()
  } else {
    first = a[prop].toUpperCase() // ignore upper and lowercase
    second = b[prop].toUpperCase() // ignore upper and lowercase
  }

  if (first < second) {
    return -1 * sign // a negative number if the first element should go before the second, in this case it stays
  }
  if (first > second) {
    return 1 * sign // a positive number if the first element should go after the second
  }

  // if 0 then do nothing
  return 0
}

/**
 * This function verifies in the frontend only if the currently logged user has an admin role.
 */
export function isAdmin() {
  /**
   * Gets the roles from the store and use that
   * for verification instead of acl.hasPermission('general_system_admin')
   * because when the user changes active institution it will replace all
   * permissions inside acl.
   */
  const roles = store.getters['userRoles']
  const permissions = store.getters['userPermissions']

  if (roles && isArray(roles)) {
    return roles.some((role) => role.name === 'admin') || permissions.some((permission) => permission.name === 'system_admin')
  }

  return false || permissions.some((permission) => permission.name === 'system_admin')
}

export function toastedNotify(options) {
  const vuesaxToToast_typeConversion = {
    primary: 'info',
    danger: 'error',
    warning: 'warning',
    error: 'error',
    dark: 'default'
  }

  switch (options.color) {
    case 'danger':
      options.text = `Erro!!! ${options.text}`
      break;

    default:
      break;
  }

  if ('$toast' in Vue) {
    (Vue as any).$toast(options.text, {
      type: vuesaxToToast_typeConversion[options.color],
    })
  }

}

export function serializeFormData(obj: any) {
  const normalData = mapValues(obj, (data, key) => {
    if (isArray(data) && data.length > 0 && 'files' in data[0]) {
      return data.map(
        (list) => list.files.map((fileObj) => fileObj.file)
      )
    }

    if (isObject(data) && 'files' in data) {
      return (data as any).files.map((fileObj) => fileObj.file)
    }

    return data
  })
  console.log(normalData)
  return serialize(normalData, {indices: true, nullsAsUndefineds: true})
}

export function emailValidate(email: String) {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

  if(email && email.match(validRegex)){
    return true
  }
  return false
}

export function clearObjectData(obj: Object){
  Object.keys(obj).forEach( key => {
            if (isObject(obj[key])) {
              //clearObjectData(obj[key]); //Don't do that, force it manually
            } else {
              if (isArray(obj[key])) {
                obj[key] = [];
              }else if(isString(obj[key])){
                obj[key] = '';
              }else if(isBoolean(obj[key])){
                obj[key] = null;
              }
            }
        }
    );
}
